import { Title, Texts, Media, Button } from "../Object";
import { Space } from "../Layout";

const About = (props) => {

  return (
    <>
      {/* <div className="l-row"> */}
        <div className="p-box__left-auto--about">
          <Texts slug="about/body"></Texts>
          <Space size={['56px 0 0', '48px 0 0']}>
            <Space size={['0 0 0 auto', '0 auto']}>
              <Button link="/about/" slug="about" ></Button>
            </Space>
          </Space>
        </div>
      {/* </div> */}
    </>
  );
};
export default About;
